export const ADMIN_DASHBOARD_PATH = "/app/admin/dashboard";

/**
 * Secondary destinations for the sidebar More popover.
 * Only real app routes — no placeholder Instagram items.
 */
export const getMoreMenuNavItems = (isAdmin) => {
  const items = [];

  if (isAdmin) {
    items.push({
      id: "admin",
      text: "Admin",
      path: ADMIN_DASHBOARD_PATH,
    });
  }

  return items;
};
